<template>
  <div>
    <AddNewPhysician></AddNewPhysician>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const AddNewPhysician = defineAsyncComponent(() =>
  import("@/components/physicians/AddNewPhysician")
);
export default {
  components: {
    AddNewPhysician,
  },
};
</script>
